import { Directive, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { AuthService } from '../shared/auth.service';

@Directive({
    selector: '[isNotRestricted]',
    standalone: false
})
export class IsNotRestrictedDirective implements OnInit {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) {

  }

  public ngOnInit(): void {

    if (this.authService.isRestricted() !== true) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

}
